import { Toast } from "@tento-ui/components/toast/toast";
import { Storybook } from "@tento-ui/ui/storybook";
import { EventDescriptionContainer } from "./event-description-container";
import { Div } from "@tento-ui/component-builtin";

export class EventDescriptionContainerStoryBook extends Storybook.Default {
  title(): string {
    return "Event Description Container";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Editable",
        render: () => {
          return EventDescriptionContainer.makeWith({
            html: "<p>Click to edit this description.</p>",
            editable: true,
            onChange: (html) => {
              Toast.info("Description changed", {
                description: html?.slice(0, 100),
              });
            },
          }).assignStyles({
            width: "100%",
            maxWidth: "400px",
            border: "1px solid var(--divider)",
          });
        },
      },
      {
        title: "Readonly",
        render: () => {
          return EventDescriptionContainer.makeWith({
            html: "<p>This is a sample event description with some <strong>bold text</strong> and <em>italic text</em>.</p>",
            editable: false,
          }).assignStyles({
            width: "100%",
            maxWidth: "400px",
            border: "1px solid var(--divider)",
          });
        },
      },
      {
        title: "Editable (Empty)",
        render: () => {
          return EventDescriptionContainer.makeWith({
            html: undefined,
            editable: true,
            onChange: (html) => {
              Toast.info("Description changed", {
                description: html?.slice(0, 100),
              });
            },
          }).assignStyles({
            width: "100%",
            maxWidth: "400px",
            border: "1px solid var(--divider)",
          });
        },
      },
      {
        title: "Long Content (Scrollable)",
        render: () => {
          const longContent = `
            <p>This is a longer description that should trigger scrolling behavior.</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
            <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
            <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.</p>
            <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit.</p>
            <p>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.</p>
          `;
          return EventDescriptionContainer.makeWith({
            html: longContent,
            editable: false,
          }).assignStyles({
            width: "100%",
            maxWidth: "400px",
            border: "1px solid var(--divider)",
          });
        },
      },
      {
        title: "Empty Readonly (Hidden)",
        render: () => {
          return EventDescriptionContainer.makeWith({
            html: null,
            editable: false,
          }).assignStyles({
            width: "100%",
            maxWidth: "400px",
            border: "1px solid var(--divider)",
          });
        },
      },
    ];
  }
}
